import React, { Component } from "react"
import config from "react-global-configuration"

class CheckoutRefund extends Component {
  constructor(props) {
    super(props)
    this.selectedRef = React.createRef()
    this.unselectedRef = React.createRef()
  }
  // handleRadioClick(value) {
  //     this.props.updateCheckoutState('wantRefund', value)
  // }

  render() {
    const textKeys = config.get("textKeys.checkout.refund") || {}
    if (!this.props.bookingExtras) return ""

    const { product } = this.props.bookingResult

    const hideRefundGuarantee = (product && product.dynamicFields && product.dynamicFields && product.dynamicFields.hideRefundGuarantee) || false

    if (hideRefundGuarantee) return ""

    const showInCheckoutExtras = this.props.bookingExtras.filter((be) => be.showBookingPage)
    if (!showInCheckoutExtras) return null
    return showInCheckoutExtras.map((extra, index) => {
      const offer = extra.offerLines.find((o) => true)
      const hasSelectedRefundproduct = !!(
        this.props.bookingResult &&
        this.props.bookingResult.extras &&
        this.props.bookingResult.extras.find((e) => e.id === extra.id)
      )
      if (!this.props.loadRemoveExtraFromBooking && !this.props.loadingAddExtraToBooking) {
        // if not loading update
        if (this.selectedRef.current) this.selectedRef.current.checked = hasSelectedRefundproduct
        if (this.unselectedRef) this.unselectedRef.current.checked = !hasSelectedRefundproduct
      }
      const extraUnselectedBodyText = extra.dynamicFields && extra.dynamicFields.unselectedDescription
      return (
        <div className="form--parking__refund" key={index}>
          <header className="form__header">
            <h4>{offer.name}</h4>
          </header>
          <div className="form__section form__section--short form__section--light">
            <div className="form__section__inner">
              <div className={"form__field form__field--radio is-bound"}>
                <label className="form__label">
                  <input
                    className="form__item "
                    name="refundradios"
                    type="radio"
                    ref={this.unselectedRef}
                    defaultChecked={!hasSelectedRefundproduct}
                    onClick={() => this.props.removeExtraFromBooking(extra)}
                  />
                  <span className="form__label__text">
                    <h5>
                      {textKeys.no || "Ingen"} {offer.name}
                    </h5>
                    <span
                      dangerouslySetInnerHTML={{
                        __html:
                          extraUnselectedBodyText ||
                          "Hardcoded: Without a refund guarantee no refund will be available after your 14 day cancellation option expires",
                      }}
                    ></span>
                  </span>
                  <h4>
                    <span>{textKeys.valuta || "DKK"} </span>
                    {this.props.priceFormatter(0)}
                  </h4>
                </label>
              </div>
            </div>
          </div>
          <div className="form__section form__section--short form__section--light">
            <div className="form__section__inner">
              <div className={"form__field form__field--radio is-bound"}>
                <label className="form__label">
                  <input
                    className="form__item "
                    name="refundradios"
                    type="radio"
                    ref={this.selectedRef}
                    defaultChecked={hasSelectedRefundproduct}
                    onClick={() => this.props.addExtraToBooking(extra, offer)}
                  />
                  <span className="form__label__text">
                    <h5>
                      {textKeys.yes || "Tilføj"} {offer.name}
                    </h5>
                    <span dangerouslySetInnerHTML={{ __html: extra.description }}></span>
                  </span>
                  <h4>
                    <span>{textKeys.valuta || "DKK"} </span>
                    {this.props.priceFormatter(offer.totalPricePerUnit)}
                  </h4>
                </label>
              </div>
            </div>
          </div>
        </div>
      )
    })
  }
}
export default CheckoutRefund
